<template>
    <header class="sticky top-0 left-0 right-0 bg-deep-blue py-3 px-6 z-30">
        <div class="flex justify-between items-center">
            <div id="logo">
                <img :src="global.app.url + 'images/logo.svg'" alt="Options Desk logo" title="Options Desk" />
            </div>
            <div class="menu-container">
                <span v-if="user != undefined && user.access_token && user.role =='Admin' && submission.id" class="cursor-pointer mr-4" @click="goToAdminDashboard()">Admin Dashboard</span>
                <!-- Just a simple logout button for now -->
                <span v-if="user != undefined && user.access_token" class="cursor-pointer" @click="handleLogout()">Logout</span>
            </div>
        </div>

        <AlertComponent v-if="user != undefined && user.access_token && user.role =='Admin' && submission.id && $route.name != 'not-found'" color="warning" :message="'You are currently modifying the application submission of: <strong>' + submission.personal_details.first_name + ' ' + submission.personal_details.last_name + ' (' + submission.email + ').<br /><br />Changes are saved automatically.</strong>'" class="mt-8" />

        <div v-if="currentRouteName == 'create-account'" class="mt-6">
            <StepperComponent />
        </div>
    </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StepperComponent from '@components/misc/StepperComponent';

export default {
    name: "HeaderComponent",
    data: function () {
        return {};
    },
    components:{
        StepperComponent
    },
    computed:{
        ...mapGetters(["global", "user", "submission"]),
        currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        ...mapActions(["doLogout"]),
        handleLogout(){
            this.doLogout().then(response => {
                this.$router.go({ name: 'login' });
            });
        },
        goToAdminDashboard(){
            let adminDashboardUrl = this.$router.resolve({
                name: "admin-user-submission",
                params: { user: this.submission.id }
            });
            window.location.replace(adminDashboardUrl.href);
        }
    },
};
</script>
